import './styles.less';
import React from 'react';
import { Button } from 'components/Button';
import { withLayout } from 'helpers';
import { useTracker } from 'utils/tracking';
import bgImage from 'assets/ttu/ttu-step-0.avif';
import { NueLogo } from 'components/Icons';

function Start(props) {
  const trackOnce = useTracker();

  return (
    <div className="start-container">
      {/* Left side */}
      <div className="left">
        <NueLogo />

        <h1 className="label start_title">
          Is Nue Life right for me?
          <br />
          Take the assessment
        </h1>

        <p>My Ketamine Home is now powered by Nue Life</p>

        <div className="started_button_container">
          <Button
            secondary
            fluid
            className={'started_button'}
            onClick={() => {
              trackOnce('lead_question1_survey_welcome');
              props.history.push('/talk-to-us/state');
            }}>
            Get Started
          </Button>
        </div>
      </div>

      {/* Right side */}
      <div className="right">
        <img src={bgImage} />
      </div>
    </div>
  );
}

Start.displayName = 'Talk to Us | Ketamine Therapy Consultation | Nue Life';
Start.description =
  'Talk to one of our experts to help you identify which Nue Life ketamine therapy program is the best fit to start your journey to mental wellness.';

export default withLayout(Start);